import React, { Component } from 'react';
import { Button, Popconfirm, message } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TableC from '../../basicElement/TableC';
// import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import CoFilter from './components/CoFilter';
import ExportFixedLine from './components/ExportFixedLine';
import CoUpdate from './components/CoUpdate';
import { CoOperationLog, CoApprovalOperationLog } from './components/OperationLog';
import ApprovalModal from './components/ApprovalModal';
import format from '../../shared/format';
import { saveParams } from '../../../actions/noticeActions';

class CoFollowTable extends Component {
    static childContextTypes = {
        configure: PropTypes.object,
    }

    state={
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        configure: {},
    }

    getChildContext = () => {
        const { configure } = this.state;
        return {
            configure,
        };
    }

    componentDidMount() {
        const { params = {} } = this.props;
        this.loadData({ ...params });
        // this.queryInvestigationStageByInvId();
        this.getCoTraceConfigure();
        if (params.coTraceNum) {
            const { searchParams } = this.state;
            this.setState({ searchParams: {
                ...searchParams,
                coTraceNum: params.coTraceNum,
            } }, () => {
                this.props.saveParams({ coTraceNum: '' });
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.status && this.props.status) {
            this.loadData();
        }
    }

    loadData = (noticeParams = {}) => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const params = this.splitParams(searchParams);
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryCoTraceList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
                ...noticeParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    delete = coTraceId => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.delCoTrace,
            data: { coTraceId },
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                message.success(success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }
    update = (type, record) => {
        this.setState({
            type,
            record,
        }, () => {
            !type && this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        Fetch.post(API_URL.investigation.exportCoTraceList, { ...sortParams, ...params })
        .then(res => {
            message.success(res.success);
        }).catch(error => {
            console.error(error);
        });
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    getCoTraceConfigure = () => {
        const options = {
            method: 'POST',
            url: API_URL.investigation.getCoTraceConfigure,
            data: { },
            dataType: 'json',
            doneResult: res => {
                const { configureList = [] } = res;
                const CO_POSSIBILITY = configureList && configureList.filter(item => item.typeName == 'CO_POSSIBILITY'); // 可能行
                const CO_REASON = configureList && configureList.filter(item => item.typeName == 'CO_REASON'); // 原因
                const CO_INVOICE_RATE = configureList && configureList.filter(item => item.typeName == 'CO_INVOICE_RATE'); // CO发票税率
                this.setState({
                    configure: {
                        CO_POSSIBILITY,
                        CO_REASON,
                        CO_INVOICE_RATE,
                    },
                });
            },
        };
        $.sendRequest(options);
    }

    splitParams = params => {
        const result = {};
        for (const [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = searchParams => {
        this.setState({ searchParams });
    }

    filterDate = text => text ? text.slice(0, 10) : '';

    handleStringLinefeed = text => {
        const arr = (text || '').split('；');
        const result = arr.map((item, index) => <span key={index}>{item}{index < arr.length - 1 ? ';' : ''}<br /></span>);
        return result;
    }

    percentSuffix = text => (text || text == 0) ? `${text}%` : '';

    getColumns = () => {
        const columns = [{
            title: 'CO跟踪单号',
            dataIndex: 'coTraceNum',
            key: 'coTraceNum',
            fixed: 'left',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
            fixed: 'left',
        }, {
            title: '更新日期',
            dataIndex: 'updateTime',
            key: 'updateTime',
            width: 100,
            fixed: 'left',
            render: this.filterDate,
        }, {
            title: '更新次数',
            dataIndex: 'updateCount',
            key: 'updateCount',
            width: 80,
        }, {
            title: 'CO发起日期',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 100,
            render: this.filterDate,
        }, {
            title: 'CO跟进状态',
            dataIndex: 'followUpStatus',
            key: 'followUpStatus',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 100,
        }, {
            title: '项目类型',
            dataIndex: 'investigationGlobalTypeName',
            key: 'investigationGlobalTypeName',
            width: 120,
        }, {
            title: '项目分期',
            dataIndex: 'byStageNames',
            key: 'byStageNames',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'typeName',
            key: 'typeName',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessString',
            key: 'lineOfBusinessString',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeName',
            key: 'contractTypeName',
            width: 120,
        }, {
            title: 'PM',
            dataIndex: 'pmNameCodes',
            key: 'pmNameCodes',
            width: 120,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: 'PML（包含大区总监）',
            dataIndex: 'pmlNameCodes',
            key: 'pmlNameCodes',
            width: 100,
        }, {
            title: 'BD',
            dataIndex: 'bdNameCodes',
            key: 'bdNameCodes',
            width: 100,
        }, {
            title: 'CSA',
            dataIndex: 'csaNameCode',
            key: 'csaNameCode',
            width: 100,
        }, {
            title: 'BA',
            dataIndex: 'baNameCodes',
            key: 'baNameCodes',
            width: 100,
        }, {
            title: '原合同额含税/人民币(元)',
            dataIndex: 'investigationContractAmount',
            key: 'investigationContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '合同随机例数',
            dataIndex: 'contractRandomPlanAmount',
            key: 'contractRandomPlanAmount',
            width: 100,
        }, {
            title: '津石随机例数',
            dataIndex: 'jsRandomNum',
            key: 'jsRandomNum',
            width: 120,
        }, {
            title: '津石实际入组例数',
            dataIndex: 'jsActualRandomNum',
            key: 'jsActualRandomNum',
            width: 120,
        }, {
            title: '截止当月完工百分比',
            dataIndex: 'cumulativeFinishPercent',
            key: 'cumulativeFinishPercent',
            width: 80,
        }, {
            title: '计划CO金额含税/人民币(元)',
            dataIndex: 'planCoAmount',
            key: 'planCoAmount',
            width: 80,
            render: text => format('money', text),
        }, {
            title: 'CO发票税率',
            dataIndex: 'coInvoiceRateShow',
            key: 'coInvoiceRateShow',
            width: 80,
        }, {
            title: 'CO签回当月预计可开票金额',
            dataIndex: 'coBackMonthPlanInvoiceAmount',
            key: 'coBackMonthPlanInvoiceAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: 'CO可能性',
            dataIndex: 'coPossibilityShow',
            key: 'coPossibilityShow',
            width: 80,

        }, {
            title: 'CO原因',
            dataIndex: 'coReasonShow',
            key: 'coReasonShow',
            width: 80,
        }, {
            title: 'CO中已发生工作占比',
            dataIndex: 'coHappenedPercent',
            key: 'coHappenedPercent',
            width: 120,
            render: this.percentSuffix,
        }, {
            title: 'CO中未来工作占比',
            dataIndex: 'coFuturePercent',
            key: 'coFuturePercent',
            width: 120,
            render: this.percentSuffix,
        }, {
            title: '客户是否认同可CO',
            dataIndex: 'customerAgreeCo',
            key: 'customerAgreeCo',
            width: 120,
            render: text => text == '1' ? '是' : text == '0' ? '否' : '',
        }, {
            title: 'CO金额是否已达成一致',
            dataIndex: 'coAmountAgreement',
            key: 'coAmountAgreement',
            width: 240,
            render: text => text == '1' ? '是' : text == '0' ? '否' : '',
        }, {
            title: '是否有折扣',
            dataIndex: 'haveDiscount',
            key: 'haveDiscount',
            width: 120,
            render: text => text == '1' ? '是' : text == '0' ? '否' : '',
        }, {
            title: '折扣比例',
            dataIndex: 'discountPercent',
            key: 'discountPercent',
            width: 80,
            render: this.percentSuffix,
        }, {
            title: '实际CO金额含税/人民币(元)',
            dataIndex: 'actualAmount',
            key: 'actualAmount',
            width: 80,
            render: text => format('money', text),
        }, {
            title: '是否CO定稿',
            dataIndex: 'coFinalization',
            key: 'coFinalization',
            width: 80,
            render: text => text == '1' ? '是' : text == '0' ? '否' : '',
        }, {
            title: '是否已在签署流程',
            dataIndex: 'coIsSigningProcess',
            key: 'coIsSigningProcess',
            width: 100,
            render: text => text == '1' ? '是' : text == '0' ? '否' : '',
        }, {
            title: '签署节点',
            dataIndex: 'signingNode',
            key: 'signingNode',
            width: 120,
        },
        {
            title: '预计签署完成日期',
            dataIndex: 'planSignCompletedDate',
            key: 'planSignCompletedDate',
            width: 100,
            render: this.filterDate,
        }, {
            title: '实际签署完成日期',
            dataIndex: 'actualSignCompletedDate',
            key: 'actualSignCompletedDate',
            width: 140,
            render: this.filterDate,
        }, {
            title: 'CO回来当月的原累计完工%',
            dataIndex: 'coCurrentMonthPercentStr',
            key: 'coCurrentMonthPercentStr',
            width: 160,
        }, {
            title: 'CO回来入账后PM对项目完工百分比预估%',
            dataIndex: 'coBackPmFinishPercentStr',
            key: 'coBackPmFinishPercentStr',
            width: 160,
        }, {
            title: 'CO回来入账后整个项目的项目完工百分比预估',
            dataIndex: 'coInAccountPlanPercent',
            key: 'coInAccountPlanPercent',
            width: 160,
            render: this.percentSuffix,
        }, {
            title: 'CO回来后 ，该CO当月预估可确认收入/人民币(元)',
            dataIndex: 'coBackMonthPlanAmount',
            key: 'coBackMonthPlanAmount',
            width: 160,
            render: text => format('money', text),
        }, {
            title: 'CO是否已上传CTMS',
            dataIndex: 'coUploadCtms',
            key: 'coUploadCtms',
            width: 160,
            render: text => text == '1' ? '是' : text == '0' ? '否' : '',
        }, {
            title: '最近跟进进度（前面进度罗列）',
            dataIndex: 'processContent',
            key: 'processContent',
            width: 160,
        }, {
            title: '卡脖子关键环节',
            dataIndex: 'keyBlocking',
            key: 'keyBlocking',
            width: 160,
        }, {
            title: '状态',
            dataIndex: 'approvalStatus',
            key: 'approvalStatus',
            width: 100,
            render: text => text == 'WAITE' ? '待审批' : (text == 'REJECT' ? '审批不通过' : (text == 'AGREE' ? '已审批' : '')),
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            fixed: 'right',
            width: 140,
            render: (text, record) => {
                const { canEdit, canDelete, coTraceId, canApproval, approvalStatus } = record;
                const showEdit = canEdit && approvalStatus != 'WAITE';
                const showDel = canEdit;
                const showApproval = canApproval;
                return (
                    <span>
                        {showEdit && <a onClick={() => this.update('edit', record)}>修改</a>}
                        {showEdit && showDel && <span className="ant-divider" />}
                        {
                           showDel && <Popconfirm title="确定要删除?" onConfirm={() => this.delete(coTraceId)}>
                               <a>删除</a>
                           </Popconfirm>
                        }
                        {(showEdit || showDel) && showApproval && <span className="ant-divider" />}
                        {
                            showApproval && <a onClick={() => this.showApprove(record)}>CO审批</a>
                        }
                        {(showEdit || showDel || showApproval) && <span className="ant-divider" />}
                        <a onClick={() => this.viewDetail(record)}>更新日志</a>
                        <span className="ant-divider" />
                        <a onClick={() => this.viewApprovalLog(record)} style={{ display: 'inline-block' }}>操作日志</a>
                    </span>
                );
            },
        }];
        return columns;
    }

    handleTableChange = params => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    viewDetail = record => {
        this.operationLogRef.show(record);
    }

    viewApprovalLog = record => {
        this.coApprovalLogRef.show(record);
    }

    showApprove = record => {
        this.approvalModalRef.show(record);
    }

    showFixedLine = () => {
        this.exportFixedLineRef.show(API_URL.investigation.exportCoTraceRecordList);
    }

    render() {
        const { config, menuAuth } = this.props;
        const { isInvPM } = menuAuth || {};
        const { data, loading, pagination, searchParams, sortParams, type, record } = this.state;

        return (
            <div >
                {
                !type ? <div >
                    <CoFilter
                        config={config}
                        search={this.search}
                        update={this.update}
                        params={{ ...searchParams }}
                        onChange={this.handleFilterChange}
                        buttons={[
                            <Button key="export" type="primary" onClick={this.export}>导出</Button>,
                            <Button onClick={this.showFixedLine} className="btn-yellow">导出固化数据</Button>,
                            isInvPM && <Button key="add" type="primary" onClick={() => this.update('add', {})}>添加</Button>,
                        ]}
                    />
                    <TableC
                        data={data}
                        scrollY={500}
                        loading={loading}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        rowKey="coTraceId"
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                    <ExportFixedLine ref={el => this.exportFixedLineRef = el} />
                    <CoOperationLog ref={el => this.operationLogRef = el} />
                    <CoApprovalOperationLog ref={el => this.coApprovalLogRef = el} />
                    <ApprovalModal ref={el => this.approvalModalRef = el} loadData={this.loadData} />
                </div>
             :
                <div >
                    <CoUpdate
                        type={type}
                        record={record}
                        update={this.update}
                    />
                </div>
            }
            </div>
        );
    }
}


const mapStateToProps = (state, props) => ({
    menuAuth: state.menuState.menuAuth || {},
    params: state.noticeState.params,
});
const mapDispatchToProps = dispatch => ({
    saveParams: params => dispatch(saveParams(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CoFollowTable);



// WEBPACK FOOTER //
// ./src/components/contractManagement/coFollowFunds/CoFollowTable.js